<template>
  <div id="search-add-from-library-modal">
    <template v-if="!showModal">
      <a
        v-if="enableBioMaterialTypeSelect"
        @click.prevent="displayModal"
        href="#"
        id="add-bio-materials-trigger"
        >Add biological material to {{ groupTitle }}</a
      >
      <a v-else @click.prevent="displayModal" href="#" :id="linkId"
        >Add {{ materialTypeLabel }}</a
      >
    </template>
    <b-modal
      ref="searchAddModal"
      scrollable
      centered
      cancel-disabled
      ok-disabled
      no-stacking
      hide-footer
      hide-header
      :size="modalSize"
      :id="modalId"
      :data-test="'modal ' + getModalTitle"
      no-close-on-backdrop
      no-close-on-esc
      no-enforce-focus
    >
      <div v-if="showAssociateMaterials">
        <VHeader :modal-button="true" @close-modal="closeModal">
          <template #modal-title
            >Biological Materials Associated with Research Project</template
          >
        </VHeader>
        <BioProjectMaterials :group-nid="groupNid" @close-modal="closeModal" />
      </div>
      <BioMaterialTypeSelect
        v-else-if="!materialTypeToAdd && enableBioMaterialTypeSelect"
        :bio-material-bundles="bioMaterialBundles"
        @material-type-selected="setMaterialTypeToAdd"
        @close-modal="closeModal"
      />
      <SearchAddFromLibraryParent
        v-else
        :material-type-label="materialTypeLabel || materialTypeToAddLabel"
        :group-nid="groupNid"
        :material-type="materialType || materialTypeToAdd"
        @cancel-search-add="closeModal"
        @parent-status="handleEmitParentStatus"
      />
    </b-modal>
  </div>
</template>

<script>
import { useQueryString } from "@/composables/useQueryString";
import BioMaterialTypeSelect from "./BioMaterialTypeSelect.vue";
import SearchAddFromLibraryParent from "./SearchAddFromLibraryParent.vue";
import BioProjectMaterials from "./BioProjectMaterials.vue";
import VHeader from "../raft/VHeader.vue";

export default {
  name: "SearchAddFromLibraryModal",
  components: {
    BioMaterialTypeSelect,
    SearchAddFromLibraryParent,
    BioProjectMaterials,
    VHeader,
  },
  props: {
    id: { type: String, default: "insLib" },
    groupNid: { type: String, required: true },
    // materialType is REQUIRED if in Bio Materials page
    materialType: { type: String, default: "" },
    // materialTypeLabel is REQUIRED if in Bio Materials page
    materialTypeLabel: { type: String, default: "" },
    urlSearchParams: { type: URLSearchParams, default: null },
    // ENABLED if in Project Association page
    enableBioMaterialTypeSelect: { type: Boolean, default: false },
    // groupTitle is REQUIRED if in Project Association
    groupTitle: { type: String, default: "group" },
    // bioMaterialBundles is REQUIRED if in Project Association
    bioMaterialBundles: { type: Array, default: null },
    // Hides link when within BioProjectMaterialsModal using QueryModals
    showModal: { type: Boolean, default: false },
  },
  data() {
    return {
      materialTypeToAdd: null,
      materialTypeToAddLabel: null,
      showAssociateMaterials: false,
    };
  },
  computed: {
    modalId() {
      return "bio-lib-listing-" + this.materialType + "-list-modal";
    },
    linkId() {
      return "biological-listing-add-" + this.materialType;
    },
    getModalTitle() {
      return "Add " + this.materialTypeLabel + " From Library";
    },
    modalSize() {
      if (!this.enableBioMaterialTypeSelect) {
        return "lg";
      }
      if (this.materialTypeToAdd) {
        return "lg";
      }
      return "md";
    },
  },
  setup() {
    const { updateQueryString, removeQueryString } = useQueryString();
    return {
      updateQueryString,
      removeQueryString,
    };
  },
  async created() {
    if (
      this.urlSearchParams &&
      this.urlSearchParams.get("search-add-from-library") === this.materialType
    ) {
      this.displayModal();
    }
  },
  mounted() {
    if (this.showModal) {
      this.displayModal();
    }
  },
  methods: {
    errorEmit(message, data) {
      this.$emit("form-error-message", { message: message, data: data });
    },
    displayModal() {
      this.$refs.searchAddModal.show();
    },
    closeModal() {
      this.$refs.searchAddModal.hide();
      this.materialTypeToAdd = null;
      this.materialTypeToAddLabel = null;
      this.removeQueryString("modal");
      this.removeQueryString("bundles");
      window.location.reload();
    },
    setMaterialTypeToAdd(type) {
      const typeData = this.bioMaterialBundles?.find(
        (bundle) => bundle.id === type,
      );
      this.materialTypeToAdd = type;
      if (typeData) {
        this.materialTypeToAddLabel = typeData.label;
      }
    },
    handleEmitParentStatus({ status }) {
      if (status === "cancel-search-add") {
        this.closeModal();
      }
      if (status === "associate-materials") {
        this.showAssociateMaterials = true;
        this.$emit("associate-materials");
      }
      if (status === "back") {
        this.materialTypeToAdd = null;
        this.materialTypeToAddLabel = null;
      }
    },
  },
};
</script>
